var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 19.762 6-6.461-1.111-1.032-4.13 4.448V5h-1.517v11.717l-4.13-4.448L6 13.3l6 6.461Z",
    fill: "currentColor"
  })));
};
export { SvgArrowDown as ReactComponent };
export default __webpack_public_path__ + "c5dc4edf17773aadf299f3e86ffd7761.svg";